import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const CIContainer = styled.div`
    width: 100%;
    padding: 0.3rem 0.9rem;
    margin-bottom: 2rem;
    box-shadow: 0px 3px 6px #00000029;
    border-radius: 18px;
    background-color: #FFFFFF;
`;

export const CITitle = styled.span`
    font-size: 1.1rem;
    // font-weight: bold;
    margin: 0;
    margin-left: 10px;
    padding: 0;
`

export const CIContent = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    font-size: 0.9rem;

    @media (max-width: ${({theme}) => theme.size.laptopL}) {
        font-size: 0.8rem;
    }
`

export const CIData = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
    flex-wrap: wrap;
    margin-bottom: 0.5rem;
`

export const CIActions = styled.div`
    display: flex;
    justify-content: flex-end;
    // align-items: flex-end;
    margin-bottom: 0.5rem;
`


export const UpdateLink = styled(Link)`
    display: flex;
    justify-content: center;
    align-items: center;
    /* font-size: 1rem; */
    width: fit-content;

    &:hover {
        color: ${({theme}) => theme.colors.success};
    }

    @media (max-width: ${({theme}) => theme.size.laptopL}) {
       
    }
`

